import React from "react";
import withStyles from "react-jss";
import Textarea from "react-textarea-autosize";
import classNames from "classnames";

const styles = (theme) => ({
	root: {
		position: "relative",
	},
	ta: {
		minHeight: "150px",
		width: "100%",
		resize: "none",
		borderRadius: "10px",
		border: `1px solid ${theme.palette.colors.disabled}`,
		color: theme.palette.colors.darkSlateBlue2,
		backgroundColor: "transparent",
		padding: "15px 15px 30px",
		fontSize: "14px",
		fontFamily: theme.fonts.light,
	},
	message: {
		fontSize: "16px",
		fontFamily: theme.fonts.light,
		color: theme.palette.colors.oneMoreGrey,
		position: "absolute",
		right: "16px",
		bottom: "16px",
	},
	isError: {
		"& $ta": {
			borderColor: theme.palette.colors.coralPink,
		},
		"& $message": {
			color: theme.palette.colors.coralPink,
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		ta: {
			minHeight: "138px",
		},
		message: {
			fontSize: "14px",
		},
	},
});

class TextArea extends React.Component {
	render() {
		let classes = this.props.classes;
		let { error, ...rest } = this.props;
		return (
			<div
				className={classNames(classes.root, {
					[classes.isError]: error,
				})}
			>
				<Textarea {...rest} className={classes.ta} />
			</div>
		);
	}
}

export default withStyles(styles)(TextArea);
